import { render } from "./MenuDropdowns.vue?vue&type=template&id=200fa914"
import script from "./MenuDropdowns.vue?vue&type=script&lang=js"
export * from "./MenuDropdowns.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__